import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t-4 border-amber-600 py-12 relative overflow-hidden" data-id="element-261">
      {/* Animated background */}
      <div className="absolute inset-0 opacity-5 animate-scanline" style={{
      backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, #00ff00 2px, #00ff00 4px)'
    }} data-id="element-262" />
      <div className="absolute inset-0 opacity-5 animate-grid-pulse" style={{
      backgroundImage: 'radial-gradient(circle at 50% 50%, #ffa500 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-263" />
      {/* Floating particles */}
      {[...Array(15)].map((_, i) => <div key={i} className="absolute rounded-full animate-float" style={{
      width: `${2 + Math.random() * 3}px`,
      height: `${2 + Math.random() * 3}px`,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      backgroundColor: i % 2 === 0 ? '#22c55e' : '#f59e0b',
      animationDelay: `${Math.random() * 5}s`,
      animationDuration: `${10 + Math.random() * 15}s`,
      opacity: 0.3
    }} data-id="element-264" />)}
      <div className="container mx-auto px-6 relative z-10" data-id="element-265">
        <div className="max-w-6xl mx-auto" data-id="element-266">
          <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-267">
            {/* Brand */}
            <div className="md:col-span-2 group animate-fade-in-up" data-id="element-268">
              <div className="relative inline-block" data-id="element-269">
                <div className="absolute inset-0 bg-amber-500 opacity-0 group-hover:opacity-20 blur-xl transition-opacity duration-500" data-id="element-270" />
                <h3 className="text-2xl font-bold text-amber-500 mb-2 font-mono relative z-10 group-hover:text-glow transition-all duration-300" data-id="element-271">
                  DILBERT RATIO GROUP
                </h3>
              </div>
              <div className="flex items-center gap-2 mb-4" data-id="element-272">
                <div className="w-2 h-2 bg-green-400 animate-pulse" data-id="element-273" />
                <p className="text-green-400 text-sm font-mono" data-id="element-274">
                  AUTOMATION PARTNERS
                </p>
              </div>
              <div className="border-l-4 border-amber-600 pl-4 py-2 bg-amber-950/10 hover:bg-amber-950/20 transition-colors duration-300 group/text relative overflow-hidden" data-id="element-275">
                <div className="absolute left-0 top-0 bottom-0 w-1 bg-amber-400 transform scale-y-0 group-hover/text:scale-y-100 transition-transform duration-500" data-id="element-276" />
                <p className="text-amber-100 text-sm leading-relaxed max-w-md relative z-10" data-id="element-277">
                  We challenge, delete, simplify, accelerate—then automate.
                  Building systems that drive profit, not just features.
                </p>
              </div>
            </div>
            {/* Contact */}
            <div className="animate-fade-in-up" style={{
            animationDelay: '0.1s'
          }} data-id="element-278">
              <div className="border-b-2 border-amber-600 pb-2 mb-4 relative group" data-id="element-279">
                <div className="absolute bottom-0 left-0 h-0.5 w-0 group-hover:w-full bg-green-400 transition-all duration-500" data-id="element-280" />
                <h4 className="text-amber-500 font-mono text-sm group-hover:text-glow transition-all duration-300" data-id="element-281">
                  CONNECT
                </h4>
              </div>
              <div className="space-y-2 text-sm" data-id="element-282">
                <div className="group/linkedin hover:translate-x-2 transition-transform duration-300" data-id="element-283">
                  <div className="flex items-center gap-2 mb-1" data-id="element-284">
                    <div className="w-2 h-2 bg-green-400 animate-pulse" data-id="element-285" />
                    <span className="text-green-400 font-mono text-xs" data-id="element-286">
                      {'>'} LINKEDIN:
                    </span>
                  </div>
                  <a href="https://www.linkedin.com/in/dawsonsewell" target="_blank" rel="noopener noreferrer" className="text-green-400 font-mono hover:text-amber-500 transition-colors duration-300 block pl-4 group-hover/linkedin:text-glow" data-id="element-287">
                    Connect with Dawson
                  </a>
                </div>
                <div className="pl-4 hover:translate-x-2 transition-transform duration-300" data-id="element-288">
                  <p className="text-amber-100 flex items-center gap-2" data-id="element-289">
                    <span className="text-green-400 text-xs" data-id="element-290">{'>'}</span>
                    Response time: {'<'}24 hours
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Bottom */}
          <div className="border-t-2 border-amber-600 pt-6 relative animate-fade-in-up group" style={{
          animationDelay: '0.2s'
        }} data-id="element-291">
            <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-green-400 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-292" />
            {/* Corner accents */}
            <div className="absolute top-2 left-0 w-6 h-6 border-t-2 border-l-2 border-green-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-pulse" data-id="element-293" />
            <div className="absolute top-2 right-0 w-6 h-6 border-t-2 border-r-2 border-amber-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-pulse" style={{
            animationDelay: '0.3s'
          }} data-id="element-294" />
            <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-295">
              <div className="flex items-center gap-3 group/year hover:scale-105 transition-transform duration-300" data-id="element-296">
                <div className="w-3 h-3 border-2 border-green-400 rotate-45 animate-pulse group-hover/year:rotate-90 transition-transform duration-500" data-id="element-297" />
                <p className="text-green-400 text-sm font-mono group-hover/year:text-glow transition-all duration-300" data-id="element-298">
                  © 2077 DILBERT RATIO GROUP
                </p>
                <div className="w-3 h-3 border-2 border-amber-400 rotate-45 animate-pulse group-hover/year:rotate-90 transition-transform duration-500" style={{
                animationDelay: '0.5s'
              }} data-id="element-299" />
              </div>
              <div className="flex items-center gap-2 group/built hover:scale-105 transition-transform duration-300" data-id="element-300">
                <div className="flex gap-1" data-id="element-301">
                  <div className="w-2 h-2 bg-green-500 animate-pulse" data-id="element-302" />
                  <div className="w-2 h-2 bg-amber-500 animate-pulse" style={{
                  animationDelay: '0.2s'
                }} data-id="element-303" />
                  <div className="w-2 h-2 bg-green-500 animate-pulse" style={{
                  animationDelay: '0.4s'
                }} data-id="element-304" />
                </div>
                <p className="text-amber-100 text-xs group-hover/built:text-amber-500 transition-colors duration-300" data-id="element-305">
                  Built with the algorithm. Naturally.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style data-id="element-306">{`
        @keyframes scanline {
          0% { transform: translateY(0); }
          100% { transform: translateY(100%); }
        }
        @keyframes grid-pulse {
          0%, 100% { opacity: 0.05; }
          50% { opacity: 0.1; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0) rotate(0deg); }
          50% { transform: translateY(-80px) translateX(40px) rotate(180deg); }
        }
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-scanline {
          animation: scanline 8s linear infinite;
        }
        .animate-grid-pulse {
          animation: grid-pulse 4s ease-in-out infinite;
        }
        .animate-float {
          animation: float linear infinite;
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
        .text-glow {
          text-shadow: 0 0 20px currentColor;
        }
      `}</style>
    </footer>;
}